import {CA} from '../../analytics/Analytics'
// eslint-disable-next-line no-restricted-imports
import {UIPopupController} from '../../ui_popup/UIPopupController'
import {UIGameManager} from '../UIGameManager'
import {TranslationObject} from '@colonist/i18n'
import {ViewPopupOptions} from '../../ui_popup/ViewPopupOptions'
import {UIFeedbackFormPopupController} from '../../ui_popup/ui_popup_feedback_form/UIFeedbackFormPopupController'
import {FeedbackFormLocationEnum} from '../../../../../shared/entity_datas/EntityDatas'
import {socket} from '../../EntryShared'
import {FeedbackFormUtils} from '../../ui_popup/ui_popup_feedback_form/FeedbackFormUtils'
import {getHomepageUrl, navigateToPage} from '../../ui_utils/ClientUtils'

export default class UIGameLeaveButton {
    static clicked(uiGameManager: UIGameManager) {
        const isViewingReplayOnProfilePage = window.location.href.includes('/profile')
        if(isViewingReplayOnProfilePage) return location.reload()

        if(uiGameManager.gameState.canResign) {
            this.createResignGamePopup(uiGameManager)
            return
        }
        UIGameLeaveButton.createStandardLeaveGamePopup(uiGameManager)
    }

    private static createStandardLeaveGamePopup(uiGameManager: UIGameManager) {
        const title: TranslationObject = {key: 'strings:game.leaveGame.title'}
        const body: TranslationObject = {key: 'strings:game.leaveGame.body'}

        CA.sendGoogleAnalyticsEvent(CA.Category.Game, CA.Label.ClickedGameLobbyButton)

        const leaveGameAction = () => this.showPopupsBeforeExitingGame(() => {
            CA.sendGoogleAnalyticsEvent(CA.Category.Game, CA.Label.ClickedGameLobbyButtonAccept)
            uiGameManager.socketGameSend.leaveGame()
            navigateToPage(getHomepageUrl())
        })

        UIPopupController.create(title, body, leaveGameAction, () => undefined)
    }

    private static createResignGamePopup(uiGameManager: UIGameManager) {
        const title: TranslationObject = {key: 'strings:game.resign.title'}
        const body: TranslationObject = {key: 'strings:game.resign.body'}

        const popupOptions: ViewPopupOptions = {
            showXButton: true,
            showCheckButton: true,
            xButtonCustomContent: {key: 'strings:colonistCommon.buttons.cancel'},
            checkButtonCustomContent: {key: 'strings:game.resign.title'},
        }

        const cancelAction = () => undefined
        const resignAction = () => this.showPopupsBeforeExitingGame(() => uiGameManager.socketGameSend.resign())

        UIPopupController.create(title, body, resignAction, cancelAction, true, popupOptions)
    }

    private static showPopupsBeforeExitingGame(continuationAction: () => void) {
        const shouldShowFeedbackForm = FeedbackFormUtils.shouldShowFeedbackForm()
        if(shouldShowFeedbackForm) {
            new UIFeedbackFormPopupController(() => continuationAction(), socket.gameListener.databaseGameId, FeedbackFormLocationEnum.QuitGame)
            return
        }
        continuationAction()
    }
}
